import { addNoteToApplicantBDM, updateAllOtherSourceNotes } from "../../../redux/slices/bdmjobs/bdmjobsSlice";
import {
  addNoteToApplicant,
  updateAllSourceNotes,
  updateExistingCandidates,
} from "../../../redux/slices/internalDbES/internalDbESlice";
import { updateApplicantNotes, updateApplicantWithNotes } from "../../../redux/slices/recruitmentSourcing/SourcingSlice";

const handlePost = (dispatch) => (packet) => {
  const title = packet?.title;
  const data = packet?.data || packet?.data?.response;
  //console.log("Notes", data)
  switch (title) {
    case "Note":
      if (data?.source === 1) {
      } else if (data?.source === 2) {
        dispatch(
          updateApplicantNotes({
            applicantId: data.candidateId,
            newNoteUiid: data.uiid,
             uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        dispatch(
          updateAllSourceNotes({
            applicantId: data.candidateId,
            newNoteUiid: data.uiid,
             uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        dispatch(
          updateAllOtherSourceNotes({
            applicantId: data.candidateId,
            newNoteUiid: data.uiid,
             uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        dispatch(
          updateApplicantWithNotes({
            applicantId: data?.candidateId,
            uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        dispatch(
          addNoteToApplicant({
            applicantId: data?.candidateId,
            uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        dispatch(
          addNoteToApplicantBDM({
            applicantId: data?.candidateId,
            uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
      }
      break;
    case "Order":
      break;
    case "monster":
      //console.log("data", data)
      dispatch(
        updateExistingCandidates({
          source: "monster",
          candidate: data,
        })
      );
      break;
    case "careerbuilder":
      dispatch(
        updateExistingCandidates({
          source: "careerBuilder",
          candidate: data,
        })
      );
      break;
    default:
      return;
  }
};

export default handlePost;
